// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3Navu","errors":"Errors_errors__2F0JQ"};